import React from "react";

// import sections
import HeroSection from "./sections/HeroSection";
import LogoStripSection from "./sections/LogoStripSection";
import StorySection from "./sections/StorySection";
import SoftSection from "./sections/SoftSection";
import HowToWorkSection from "./sections/HowToWorkSection";
import WhyChooseUsSection from "./sections/WhyChooseUsSection";
import FAQSection from "./sections/FAQSection";
import ContactUsSection from "./sections/ContactUsSection";
import FinalCtaSection from "./sections/FinalCtaSection";

const Home = () => {
  return (
    <div>
      <HeroSection />
      <LogoStripSection />
      <StorySection />
      <SoftSection />
      <HowToWorkSection />
      <WhyChooseUsSection />
      <FAQSection />
      <ContactUsSection />
      <FinalCtaSection />
    </div>
  );
};

export default Home;
